import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { RootState } from '../../store/store.state';
import { selectAuthState } from '../store/auth.store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    standalone: false,
    selector: 'q-auth-frame-token-refresh',
    templateUrl: './auth-frame-token-refresh.component.html',
    styleUrls: []
})
export class AuthFrameTokenRefreshComponent implements OnInit {
    showFrame: boolean = false;
    private destroy$ = new Subject<void>();

    constructor(private store: Store<RootState>) {}

    ngOnInit(): void {
        this.store
            .pipe(select(selectAuthState), takeUntil(this.destroy$))
            .subscribe((authState) => {
                this.showFrame = authState.ui.showFrame;
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
